<template>
    <div>
        <div>
            <el-row>
                <h1 class="project_head_title">礼品礼金申报</h1>
                <el-divider class="divider" />
            </el-row>
            <el-form label-width="120px">
                <el-divider class="divider" />

                <el-row class="form-row">
                    <el-col :span="6">
                        <el-form-item label="姓名/工号" prop="labelValue">
                            <el-input v-model="queryForm.person"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="部门" prop="labelValue">
                            <el-input v-model="queryForm.personDept"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="手机" prop="labelValue">
                            <el-input v-model="queryForm.personPhone"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item>
                            <el-button :disabled="loading" type="primary" icon="el-icon-search" @click="currentPage=1;getDataList()">搜索</el-button>
                            <!-- <el-button type="primary" icon="el-icon-download" @click="showDialog()">新增</el-button> -->
                            <el-button type="primary" @click="getDataList(true)">导出</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div v-if="show">
                    <el-row class="form-row">
                        <el-col :span="6">
                            <el-form-item label="礼品名称" prop="labelValue">
                                <el-input v-model="queryForm.name"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="送礼单位" prop="labelValue">
                                <el-input v-model="queryForm.giverCompany"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="申报时间" prop="labelValue">
                                <el-date-picker
                                    style="width:100%;"
                                    v-model="timeRange"
                                    type="daterange"
                                    range-separator="至" 
                                    start-placeholde="开始日期" 
                                    end-placeholde="结束日期" 
                                    :default-time="['00:00:00','23:59:59']"
                                    value-format="timestamp"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="处理方式" prop="labelValue">
                                <el-input v-model="queryForm.handleType"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="form-row">
                        <el-col :span="6">
                            <el-form-item label="处理人">
                                <OrgPersonTreeSelect
                                    :initValue="queryForm.supervisePersonId?queryForm.supervisePersonId.split(','):[]"
                                    :multipleSelect="false"
                                    @getSelectValue="val=>{$set(queryForm,'supervisePersonId',val.join(','))}"></OrgPersonTreeSelect>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="状态" prop="labelValue">
                                <el-select v-model="queryForm.status" clearable style="width:100%;" placeholder="请选择">
                                    <el-option value="已申请"/>
                                    <el-option value="已指派"/>
                                    <el-option value="已处理"/>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div v-if="!show" class="el-icon-caret-bottom show-menu-btn" style="cursor: pointer;" @click="show=true"></div>
                <div v-if="show" class="el-icon-caret-top show-menu-btn" style="cursor: pointer;" @click="show=false"></div>
            </el-form>
            <div v-loading="loading">
                <el-table class="tb-mini" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}" border :data="datas" @selection-change="handleSelectionChange" align="center">
                    <el-table-column label="序号" type="index" width="70" align="center">
                        <template scope="scope">
                            {{ (currentPage - 1) * pageSize + scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="personName" label="姓名" show-overflow-tooltip min-width="130px"></el-table-column>
                    <el-table-column prop="personId" label="工号" show-overflow-tooltip min-width="130px"></el-table-column>
                    <el-table-column prop="personDept" label="部门" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="personPhone" label="手机" show-overflow-tooltip min-width="110px"></el-table-column>
                    <el-table-column prop="money" label="礼金金额" show-overflow-tooltip min-width="110px"></el-table-column>
                    <el-table-column prop="name" label="礼品名称" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="value" label="礼品价值" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="giverCompany" label="送礼单位" show-overflow-tooltip min-width="150px"></el-table-column>
                    <el-table-column prop="timeStr" label="申报时间" show-overflow-tooltip min-width="130px"></el-table-column>
                    <el-table-column prop="zpTimeStr" label="指派时间" show-overflow-tooltip min-width="130px"></el-table-column>
                    <el-table-column prop="handleType" label="处理方式" show-overflow-tooltip min-width="200px"></el-table-column>
                    <el-table-column prop="clTimeStr" label="处理时间" show-overflow-tooltip min-width="130px"></el-table-column>
                    <el-table-column prop="supervisePersonIdStr" label="处理人" show-overflow-tooltip min-width="130px"></el-table-column>
                    <el-table-column prop="status" label="状态" show-overflow-tooltip width="130px"></el-table-column>
                    <!-- <el-table-column prop="fprStr" label="监督人" show-overflow-tooltip min-width="150px"></el-table-column> -->
                    <el-table-column  label="操作" width="180px" fixed="right">
                        <template slot-scope="scope">
                            <!-- <el-button type="text" @click="showDialog(scope.row.guid)">修改</el-button> -->
                            <el-button type="text" @click="handle(scope.row.guid)" v-if="scope.row.status == '已申请'&&Cookie.get('oguGuid')==scope.row.fpr">分配</el-button>
                            <el-button type="text" @click="handle(scope.row.guid)" v-if="scope.row.status == '已指派'&&Cookie.get('oguGuid')==scope.row.supervisePersonId">处理</el-button>
                            <el-button type="text" @click="showDialog(scope.row.guid,true)">详情</el-button>
                            <el-button type="text" @click="deleteById(scope.row.guid)" v-if="Cookie.get('isAdmin')">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[15, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    style="text-align:right"
                ></el-pagination>
            </div>
            <div style="text-align:left;">
                <el-button type="primary" @click="openPz" v-if="Cookie.get('isAdmin')">配置监督人</el-button>
                <el-dialog :close-on-click-modal="false" :visible.sync="pzVisible" title="配置监督人" width="40%">
                    <el-form label-width="120px" style="padding-right:100px;">
                        <el-form-item label="监督人">
                            <OrgPersonTreeSelect
                                :parentId="parentId"
                                :initValue="pzForm.labelValue?pzForm.labelValue.split(','):[]"
                                :multipleSelect="false"
                                :expandKeys="parentId"
                                @getSelectValue="val=>{$set(pzForm,'labelValue',val.join(','))}"></OrgPersonTreeSelect>
                        </el-form-item>
                    </el-form>
                    <span slot="footer" class="dialog-footer">
                        <el-button @click="pzVisible = false">取 消</el-button>
                        <el-button type="primary" @click="pzSave()">保 存</el-button>
                    </span>
                </el-dialog>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible" :title="detail?'详情':(dataForm.guid?'修改':'新增')" width="60%">
            <el-form label-width="120px" :rules="rules" ref="form" :model="dataForm" :disabled="detail" style="padding-right:100px;">
                <el-form-item label="姓名" prop="personName">
                    <el-input v-model="dataForm.personName" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="工号" prop="personId">
                    <el-input v-model="dataForm.personId" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="部门" prop="personDept">
                    <el-input v-model="dataForm.personDept" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="手机" prop="personPhone">
                    <el-input v-model="dataForm.personPhone" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="礼金金额" prop="money">
                    <el-input v-model="dataForm.money" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="礼品名称" prop="name">
                    <el-input v-model="dataForm.name" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="礼品价值" prop="value">
                    <el-input v-model="dataForm.value" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="送礼单位" prop="giverCompany">
                    <el-input v-model="dataForm.giverCompany" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="礼品附件" style="text-align: left;">
                    <Upload :disabled="detail" :fileIds="appFileListIds" @getUploadFileIds="appFileListIds=$event;form.appFiles=$event.join(',')"></Upload>
                </el-form-item>
                <el-form-item label="申报时间" prop="time">
                    <el-input v-model="dataForm.timeStr" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="指派时间" prop="time">
                    <el-input v-model="dataForm.zpTimeStr" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="监督人" prop="fpr">
                    <el-input v-model="dataForm.fprStr" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="处理方式" prop="handleType">
                    <el-input v-model="dataForm.handleType" placeholder="" clearable maxlength="1000" show-word-limit type="textarea" :autosize="{minRows:3,maxRows:15}"/>
                </el-form-item>
                <el-form-item label="处理时间" prop="time">
                    <el-input v-model="dataForm.clTimeStr" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="处理人" prop="supervisePersonId">
                    <el-input v-model="dataForm.supervisePersonIdStr" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="状态" prop="supervisePersonId">
                    <el-input v-model="dataForm.status" placeholder="" clearable/>
                </el-form-item>
                <el-form-item label="处理附件" style="text-align: left;">
                    <Upload :disabled="detail" :fileIds="fileListIds" @getUploadFileIds="fileListIds=$event;form.files=$event.join(',')"></Upload>
                </el-form-item>
            </el-form>
            <span v-if="!detail" slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="save()">保 存</el-button>
            </span>
            <span v-else slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data(){
        return {
            pzForm:{

            },
            appFileListIds:[],
            parentId:'50020020',
            orgExpandKeys: ["50020020"],
            auditParentId:'50652940',
            auditOrgExpandKeys: ["50652940"],
            pzVisible:false,
            show:false,
            detail:false,
            timeRange:[],
            fileListIds:[],
            queryForm:{
            },
            currentPage:1,
            pageSize:15,
            total: 0,
            datas: [],
            loading:false,
            dialogVisible:false,
            dataForm:{},
            rules:{
                labelValue:{required:true,message:'请填写数据',trigger:'blur'},
            },
            
            col:[['姓名','personName'],['工号','personId'],['部门','personDept'],['手机','personPhone'],['礼金金额','money'],['礼品名称','name'],['礼品价值','value'],['送礼单位','giverCompany'],['申报时间','timeStr'],['指派时间','zpTimeStr'],['处理时间','clTimeStr'],['处理方式','handleType'],['处理人','supervisePersonIdStr'],['状态','status']]
        }
    },
    mounted(){
        this.getDataList()
    },
    methods:{
        showDialog(id,detail = false){
            this.detail = detail
            this.dialogVisible = true
            this.dataForm = {}
            if(this.$refs['person']){
                this.$refs['person'].clearSelection()
            }
            if(this.$refs['form']){
                this.$refs['form'].resetFields()
            }
            
            if(id){
                this.$http.get('/api/ts/v0.1/cashGift/'+id)
                .then(res=>{
                    this.dataForm = res.data
                    this.dataForm.timeStr = this.$handlerDateToDay(res.data.time)
                    this.dataForm.zpTimeStr = this.$handlerDateToDay(res.data.zpTime)
                    this.dataForm.clTimeStr = this.$handlerDateToDay(res.data.clTime)
                    if(this.dataForm.files){
                        this.fileListIds = this.dataForm.files.split(',')
                    }else{
                        this.fileListIds = []
                    }
                    if(this.dataForm.appFiles){
                        this.appFileListIds = this.dataForm.appFiles.split(',')
                    }else{
                        this.appFileListIds = []
                    }
                    console.log(this.dataForm)
                })
            }
        },
        deleteById(id){
            this.$confirm('此操作将永久删除该数据，是否继续？','提示'
                ,{
                    confirmButtonText:'确定',
                    cancelButtonText:'取消',
                    type:'warning'
                }).then(()=>{
                    this.$http.delete('/api/ts/v0.1/cashGift/'+id).then(res=>{
                if (res.data >= 1) {
                    this.getDataList()
                    this.$message.success('操作成功')
                } else {
                    this.$message.error('操作失败')
                }
            }).catch((err)=>{
                this.$message.error('操作失败')
            })
                })
            
        },
        save(){
            console.log(this.dataForm,'1111111')
            this.$refs['form'].validate((valid)=>{
                if(valid){
                    
                    this.$http.post('/api/ts/v0.1/cashGift/save',this.dataForm)
                    .then(res=>{
                        if (res.data >= 1) {
                            this.getDataList()
                            this.dialogVisible = false
                            this.$message.success('操作成功')
                        } else {
                            this.$message.error('操作失败')
                        }
                    })
                    .catch((err)=>{
                        this.$message.error('操作失败')
                    })
                }else{
                    this.$message.error('请填写数据')
                }
            })
            
        },
        openPz(){
            this.$http.get('/api/ts/v0.1/params/getByType/FPR')
            .then(res=>{
                if(res.data){
                    this.pzForm = res.data
                }else{
                    this.pzForm = {}
                }
                this.pzVisible = true
            })
            
        },
        pzSave(){
            this.pzForm.labelType='FPR'
            this.$http.post('/api/ts/v0.1/params/save',this.pzForm)
            .then(res=>{
                if (res.data >= 1) {
                    this.pzVisible = false
                    this.$message.success('操作成功')
                } else {
                    this.$message.error('操作失败')
                }
            })
        },
        handle(guid){
            this.$router.push({
                name: "cashGiftHandle",
                query: {
                    guid:guid
                }
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.getDataList()
        },
        getDataList(isExport = false){
            if(isExport){
                this.queryForm.pageSize = 10000000
                this.queryForm.pageNum = 1
                this.exportDatas = []
            }else{
                this.queryForm.pageSize = this.pageSize
                this.queryForm.pageNum = this.currentPage
                this.datas = []
            }
            if(this.timeRange){
                this.queryForm.timeStart = this.timeRange[0]
                this.queryForm.timeEnd = this.timeRange[1]
            }else{
                this.queryForm.timeStart = undefined
                this.queryForm.timeEnd = undefined
            }
            this.queryForm.spare = 'item'
            this.$http.get('/api/ts/v0.1/cashGift/page',{params:{...this.queryForm}})
                .then(res=>{
                    if(res.status==200){
                        res.data.list = res.data.list.map(item=>{
                            item.timeStr = this.$handlerDateToDay(item.time)
                            item.zpTimeStr = this.$handlerDateToDay(item.zpTime)
                            item.clTimeStr = this.$handlerDateToDay(item.clTime)
                            return item
                        })
                        if(isExport){
                            this.$onExport(res.data.list,this.col,"礼品礼金列表")
                        }else{
                            this.datas = res.data.list
                            this.total = res.data.total
                        }
                    }else{
                        this.$message.error('查询失败！请联系管理员')
                    }
                    
                    this.loading=false;
                })
                .catch((err)=>{
                    this.loading=false;
                })
        },
    }
}
</script>

<style scoped>
    .el-date-editor.el-input, .el-date-editor.el-input__inner{
        width: 100%;
    }
    .el-select{
        width:100%;
    }
    .el-input-number{
        width: 100%;
    }
</style>